import { escapeHtml } from "../router.js";

/**
 * Segmented pill control (Todos | Câmara | Senado, Por partido | Lista…).
 * options: [{ value, label }]; the active option gets `segmented__btn--active`.
 * `attr` is the data attribute carrying the value (default "value"), so several controls can coexist.
 */
export function renderSegmented(options, active, { attr = "value", label = "", size = "" } = {}) {
  const current = options.some((o) => o.value === active) ? active : options[0]?.value ?? "";
  return `<div class="segmented ${size ? `segmented--${size}` : ""}" role="tablist" ${label ? `aria-label="${escapeHtml(label)}"` : ""} data-segmented="${escapeHtml(attr)}">${options
    .map(
      (o) =>
        `<button type="button" role="tab" class="segmented__btn ${o.value === current ? "segmented__btn--active" : ""}" data-${escapeHtml(attr)}="${escapeHtml(o.value)}" aria-selected="${o.value === current}">${escapeHtml(o.label)}</button>`,
    )
    .join("")}</div>`;
}

export function bindSegmented(root, attr, onChange) {
  const box = root.querySelector(`[data-segmented="${attr}"]`);
  if (!box) return;
  box.querySelectorAll(`[data-${attr}]`).forEach((btn) =>
    btn.addEventListener("click", () => {
      const value = btn.dataset[attr];
      box.querySelectorAll(`[data-${attr}]`).forEach((b) => {
        const on = b === btn;
        b.classList.toggle("segmented__btn--active", on);
        b.setAttribute("aria-selected", String(on));
      });
      onChange(value);
    }),
  );
}

const HOUSES = [
  { value: "", label: "Todos" },
  { value: "camara", label: "Câmara" },
  { value: "senado", label: "Senado" },
];

export function renderHouseTabs(current) {
  return renderSegmented(HOUSES, current || "", { attr: "house", label: "Casa" });
}

export function bindHouseTabs(root, onChange) {
  bindSegmented(root, "house", onChange);
}
